// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"693c19c3","455":"44ab06b5","977":"2d765b55"}[chunkId] + ".chunk.js";
};